/**
 * Player UI (PRD §7 slot states, §8 controls and look, C6, C11, C27). Builds DOM only inside
 * server-rendered slots; never inserts a slot (§9).
 */

const CSS =
  '.qsvp-slot{--qsvp-bg:#fff;--qsvp-fg:#1d1d1f;--qsvp-mu:#6b6b70;--qsvp-bd:#dcdce0;position:relative;display:block;margin:24px 0;color:var(--qsvp-fg);font:14px/1.3 system-ui,sans-serif}' +
  '@media(prefers-color-scheme:dark){.qsvp-slot{--qsvp-bg:#18181b;--qsvp-fg:#f2f2f2;--qsvp-mu:#a1a1aa;--qsvp-bd:#3f3f46}}' +
  '.qsvp-slot *{box-sizing:border-box}.qsvp-label{height:20px;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:var(--qsvp-mu);text-align:center}' +
  '.qsvp-body{position:relative}.qsvp-state{position:absolute;inset:0;display:none;align-items:center;justify-content:center;background:#f2f2f2;border-radius:8px;overflow:hidden}' +
  '.qsvp-state img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}.qsvp-state[data-kind=placeholder] img{opacity:.4}' +
  '.qsvp-state[data-kind=floating] img{opacity:.35}.qsvp-state[data-kind=empty] img{display:none}' +
  '.qsvp-corner{position:relative;background:#0009;color:#fff;padding:6px 12px;border-radius:16px}' +
  '.qsvp-watch{position:relative;min-height:44px;padding:0 18px;border:2px solid var(--qsvp-accent,#E91E63);border-radius:22px;background:var(--qsvp-bg);color:var(--qsvp-fg);font:600 15px/1 inherit;cursor:pointer}' +
  '.qsvp-slot :focus-visible{outline:2px solid var(--qsvp-accent,#E91E63);outline-offset:2px}' +
  '.qsvp-player{position:relative;margin:0 auto;background:#000;border:1px solid var(--qsvp-bd);border-radius:8px;z-index:2;container-type:inline-size}' +
  '.qsvp-player[hidden],.qsvp-ad-shell[hidden]{display:none}' +
  '.qsvp-head{height:32px;display:flex;align-items:center;gap:4px;padding:0 4px 0 8px;background:var(--qsvp-bg);border-radius:8px 8px 0 0}' +
  '.qsvp-head img{height:18px}.qsvp-title{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600;font-size:13px}' +
  '.qsvp-btn{background:none;border:0;color:inherit;cursor:pointer;min-width:32px;height:32px;padding:0 6px;font-size:16px}' +
  '.qsvp-close{width:44px;height:44px;margin:-12px -4px 0 0;align-self:flex-start;font-size:22px}' +
  '.qsvp-stage{position:relative;aspect-ratio:16/9;background:#000;overflow:hidden;border-radius:0 0 8px 8px}' +
  '.qsvp-stage video,.qsvp-poster,.qsvp-ad{position:absolute;inset:0;width:100%;height:100%}.qsvp-poster{object-fit:cover}' +
  '.qsvp-ad,.qsvp-ad-only,.qsvp-sound,.qsvp-bar,.qsvp-upnext,.qsvp-spin{display:none}' +
  '[data-mode=ad] .qsvp-ad{display:block}[data-mode=ad] .qsvp-ad-only{display:inline-block}' +
  '.qsvp-spin{position:absolute;left:50%;top:50%;width:36px;height:36px;margin:-18px;border:3px solid #fff5;border-top-color:#fff;border-radius:50%;animation:qsvp-s 1s linear infinite;pointer-events:none}' +
  '[data-loading] .qsvp-spin{display:block}@keyframes qsvp-s{to{transform:rotate(1turn)}}@media(prefers-reduced-motion:reduce){.qsvp-spin{animation:none}}' +
  '.qsvp-sound{position:absolute;left:8px;bottom:52px;background:#000b;color:#fff;border:0;border-radius:16px;padding:0 12px;min-height:32px;cursor:pointer}' +
  '[data-mode=content][data-muted] .qsvp-sound{display:block}' +
  // 2.0.5 (A50): the speaker icons are CSS content, which WordPress's emoji script never replaces with images.
  '[data-r=mute]:before{content:"🔊"}[data-muted] [data-r=mute]:before,.qsvp-sound:before{content:"🔇"}' +
  '.qsvp-bar{position:absolute;left:0;right:0;bottom:0;height:40px;align-items:center;padding:0 6px;color:#fff;background:linear-gradient(#0000,#000c);transition:opacity .2s}' +
  '[data-mode=poster] .qsvp-stage{cursor:pointer}[data-mode=poster] .qsvp-stage:after{content:"\\25B6\\FE0E";position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);font-size:44px;color:#fff;text-shadow:0 0 8px #000;pointer-events:none}' +
  '[data-mode=content] .qsvp-bar{display:flex}[data-idle] .qsvp-bar{opacity:0}.qsvp-seek{flex:1;min-width:40px}.qsvp-vol{width:64px}.qsvp-time{font-size:12px;padding:0 4px;white-space:nowrap}' +
  '@media(pointer:coarse){.qsvp-bar{height:44px}.qsvp-bar .qsvp-btn{min-width:44px;height:44px}}' +
  // 2.0.6 (A53): under 320 px (268 px phone float, narrow phones) the bar needs 310 px with 44 px touch buttons, so
  // CC and fullscreen were cut off and "↺10" wrapped. Rewind goes (the seek bar remains); the player width is always set.
  '@container(width<320px){[data-r=rewind]{display:none}}' +
  '.qsvp-upnext{position:absolute;inset:0;flex-direction:column;align-items:center;justify-content:center;gap:10px;background:#000b;color:#fff}' +
  '[data-upnext] .qsvp-upnext{display:flex}.qsvp-ad-shell{display:flex;align-items:center;justify-content:center;height:100%}' +
  '.qsvp-slot[data-state=collapsed]{height:0!important;margin:0;overflow:hidden}.qsvp-floating{position:fixed!important;margin:0!important;z-index:var(--qsvp-float-z,900)}'; // SA-11: below the site's stickies and consent banner

/**
 * Inject the player CSS once (§9: CSS injected by the script).
 * @param {Document} doc
 */
export function injectStyles(doc) {
  if (doc.getElementById('qsvp-css')) return;
  const style = doc.createElement('style');
  style.id = 'qsvp-css';
  style.textContent = CSS;
  doc.head.appendChild(style);
}

/** Static slot markup. Only fixed strings: clip titles and posters are set later via textContent/src. */
const SLOT_HTML =
  '<div class="qsvp-label">Video</div><div class="qsvp-body">' +
  '<div class="qsvp-state" data-kind="placeholder"><img alt="" loading="lazy" decoding="async"></div>' +
  '<div class="qsvp-player" tabindex="0" role="region" aria-label="Video player" hidden><div class="qsvp-head">' +
  '<span class="qsvp-title"></span>' +
  // During ads, play/pause and fullscreen live in the header, outside IMA's ad UI (C6).
  '<button type="button" class="qsvp-btn qsvp-ad-only" data-r="adPlay" aria-label="Pause">❚❚</button>' +
  '<button type="button" class="qsvp-btn qsvp-ad-only" data-r="adFull" aria-label="Fullscreen">⛶</button>' +
  '<button type="button" class="qsvp-btn" data-r="mute" aria-label="Unmute"></button>' +
  // C11: close always visible, 44x44 target, outside the ad frame (header strip).
  '<button type="button" class="qsvp-btn qsvp-close" data-r="close" aria-label="Close video">×</button></div>' +
  // preload=none (PERF-4) and playsinline (iOS 10+) are set here only. 2.0.6 (A52): crossorigin (anonymous, no cookies) so the browser loads cross-origin caption files (Bunny .vtt).
  '<div class="qsvp-stage"><video crossorigin preload="none" playsinline muted></video>' +
  '<img class="qsvp-poster" alt="" loading="lazy" decoding="async"><div class="qsvp-ad"></div>' +
  '<div class="qsvp-spin" aria-hidden="true"></div>' +
  '<button type="button" class="qsvp-sound" data-r="sound"> Tap for sound</button>' +
  '<div class="qsvp-upnext" role="status"><div data-r="upNextTitle"></div>' +
  '<button type="button" class="qsvp-watch" data-r="upNextCancel">Cancel</button></div>' +
  '<div class="qsvp-bar"><button type="button" class="qsvp-btn" data-r="play" aria-label="Pause">❚❚</button>' +
  '<button type="button" class="qsvp-btn" data-r="rewind" aria-label="Rewind 10 seconds">↺10</button>' +
  '<input class="qsvp-seek" type="range" min="0" max="1000" value="0" aria-label="Seek"><span class="qsvp-time">0:00</span>' +
  '<input class="qsvp-vol" type="range" min="0" max="1" step="0.05" value="1" aria-label="Volume">' +
  '<button type="button" class="qsvp-btn" data-r="captions" aria-label="Captions" aria-pressed="true">CC</button>' +
  '<button type="button" class="qsvp-btn" data-r="full" aria-label="Fullscreen">⛶</button></div></div></div>' +
  '<div class="qsvp-ad-shell" hidden></div></div>';

/**
 * Build the DOM inside one slot.
 * @param {object} input
 * @param {Document} input.doc
 * @param {Element} input.slot
 * @param {object} input.theme config.theme
 * @param {number} input.bodyHeight header + frame height
 * @param {boolean} input.finePointer pointer: fine
 * @returns {object} element refs
 */
export function buildSlotDom({ doc, slot, theme, bodyHeight, finePointer }) {
  slot.style.setProperty('--qsvp-accent', theme.accent || '#E91E63'); // UX-8: theme via CSS variables
  slot.innerHTML = SLOT_HTML;
  const find = (selector) => slot.querySelector(selector);
  const refs = {
    slot,
    label: find('.qsvp-label'),
    body: find('.qsvp-body'),
    state: find('.qsvp-state'),
    statePoster: find('.qsvp-state img'),
    player: find('.qsvp-player'),
    head: find('.qsvp-head'),
    title: find('.qsvp-title'),
    stage: find('.qsvp-stage'),
    video: find('video'),
    poster: find('.qsvp-poster'),
    ad: find('.qsvp-ad'),
    bar: find('.qsvp-bar'),
    seek: find('.qsvp-seek'),
    time: find('.qsvp-time'),
    volume: find('.qsvp-vol'),
    adShell: find('.qsvp-ad-shell'),
  };
  for (const el of slot.querySelectorAll('[data-r]')) refs[el.getAttribute('data-r')] = el;
  refs.body.style.height = bodyHeight + 'px';
  if (!finePointer) refs.volume.remove(); // §8: volume slider desktop only
  if (theme.logo) {
    const logo = doc.createElement('img');
    logo.src = theme.logo;
    logo.alt = '';
    refs.head.prepend(logo);
  }
  const video = refs.video;
  video.muted = true; // C2: always starts muted
  return refs;
}

/**
 * Show one of the §7 slot states. Live-ad states never show a watch button (C27).
 * @param {object} refs from buildSlotDom
 * @param {string} kind placeholder|player|floating|finished|closed|all-empty|click-to-play|fallback|collapsed
 * @param {object} [options]
 * @param {string} [options.posterUrl]
 * @param {string} [options.buttonText] e.g. "▶ Watch video"
 * @param {Function} [options.onButton]
 * @param {string} [options.dock] bottom-right|bottom-left for the corner arrow
 */
export function showSlotState(refs, kind, options = {}) {
  const { state, statePoster, player, adShell, label, slot } = refs;
  slot.setAttribute('data-state', kind);
  for (const child of Array.from(state.children)) if (child !== statePoster) child.remove();
  statePoster.style.display = '';
  if (options.posterUrl) statePoster.src = options.posterUrl;
  else statePoster.removeAttribute('src');
  const isAd = kind === 'fallback';
  label.textContent = isAd ? 'Advertisements' : 'Video'; // §3.2 step 3, UX-9
  adShell.hidden = !isAd;
  state.style.display = kind === 'player' || isAd || kind === 'collapsed' ? 'none' : 'flex';
  if (kind !== 'player' && kind !== 'floating') player.hidden = true;
  if (kind === 'player' || kind === 'floating') player.hidden = false;
  state.setAttribute(
    'data-kind',
    // No poster -> "empty", which CSS hides (an img without src shows a broken-image icon).
    kind === 'floating' ? 'floating' : !options.posterUrl ? 'empty' : kind === 'placeholder' ? 'placeholder' : 'poster',
  );
  if (kind === 'floating') {
    // §7: "Playing in the corner ↘" (↙ when docked bottom-left); no button, no play icon.
    const arrow = options.dock === 'bottom-left' ? '↙' : options.dock === 'top-right' ? '↗' : '↘';
    const corner = state.ownerDocument.createElement('span');
    corner.className = 'qsvp-corner';
    corner.textContent = 'Playing in the corner ' + arrow + '\uFE0E'; // text style: no WordPress emoji image (A50)
    state.appendChild(corner);
  }
  if (options.buttonText && !isAd) {
    const button = state.ownerDocument.createElement('button');
    button.type = 'button';
    button.className = 'qsvp-watch';
    button.textContent = options.buttonText;
    button.addEventListener('click', (event) => options.onButton && options.onButton(event));
    state.appendChild(button);
  }
}

/**
 * mm:ss
 * @param {number} seconds
 * @returns {string}
 */
export function formatTime(seconds) {
  const total = Math.max(0, Math.floor(seconds || 0));
  return Math.floor(total / 60) + ':' + String(total % 60).padStart(2, '0');
}
